"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M13.731 13.1367C13.533 13.3717 13.25 13.4927 12.965 13.4927C12.738 13.4927 12.509 13.4157 12.322 13.2587L9.356 10.7657C9.13 10.5747 9 10.2957 9 9.99969V6.97369C9 6.42069 9.448 5.97369 10 5.97369C10.552 5.97369 11 6.42069 11 6.97369V9.30169C11 9.44869 11.065 9.5887 11.178 9.68369L13.609 11.7277C14.032 12.0827 14.086 12.7137 13.731 13.1367ZM10 1.99969C5.588 1.99969 2 5.5887 2 9.99969C2 14.4107 5.588 17.9997 10 17.9997C14.411 17.9997 18 14.4107 18 9.99969C18 5.5887 14.411 1.99969 10 1.99969Z",
    fill: "#727B7F"
  }));
};